<sd-dropdown
  #dropdown
  (openedChange)="onDialogOpenChange($event)"
  [ignoreOutsideClick]="true"
  [positions]="[{ offsetY: 36, overlayY: 'top', overlayX: 'start' }]"
>
  <ng-template #dropdownToggler></ng-template>

  <ng-template #dropdownContent>
    <sd-dropdown-menu class="sd-dropdown-menu">
      <div class="text-b3-s-500 mb-2">Ваш город {{ cityName }}?</div>
      <div class="buttons">
        <button sdButton theme="primary" size="s" class="full-width" (click)="dropdown.close()">да</button>
        <button sdButton theme="secondary" size="s" class="full-width" (click)="onOpenCityList(); dropdown.close()">
          другой
        </button>
      </div>
    </sd-dropdown-menu>
  </ng-template>
</sd-dropdown>
